import React, {useEffect, useState} from 'react';
import {Button, ButtonGroup, List, ListItem, ListItemSecondaryAction, ListItemText, Paper, Popover} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {
    getActsByStatus,
    getProjects,
    getProjectsStatistic,
    selectActsStatuses,
    selectProjects,
    selectProjectsStatuses
} from "../../redux/reducers/act-statistic-reducer.js";
import {getProfile} from "../../redux/reducers/user-profile-reducer.js";
import StatusButton from "../../components/StatusButton/StatusButton.jsx";
import {makeStyles} from "@material-ui/styles";
import {selectContracts} from "../../redux/reducers/contract-reducer.js";
import {checkCondition} from "../../utils/groups.js";
import {Statuses, STATUSES_RU} from "../../utils/actStatuses";

const useStyles = makeStyles(() => ({
    popoverPaper: {
        width: 300,
        maxHeight: 500,
    },
}))

const configs = [
    {
        buttons: [
            {status: Statuses.IN_WORK_STATUS, text: STATUSES_RU.IN_WORK_STATUS},
            {status: Statuses.REJECTED_STATUS, text: STATUSES_RU.REJECTED_STATUS},
        ],
        conditions: {isStaff: false, role: 'supervisor'}
    },
    {
        buttons: [
            {status: Statuses.FOR_APPROVAL_STATUS, text: STATUSES_RU.FOR_APPROVAL_STATUS},
        ],
        conditions: {isStaff: false, role: 'moderator'}
    },
    {
        buttons: [
            {status: Statuses.APPROVED_STATUS, text: STATUSES_RU.APPROVED_STATUS},
            {status: Statuses.REJECTED_STATUS, text: STATUSES_RU.REJECTED_STATUS},
            {status: Statuses.FOR_APPROVAL_STATUS, text: STATUSES_RU.FOR_APPROVAL_STATUS},
        ],
        conditions: {isStaff: true}
    },
    {
        buttons: [
            {status: Statuses.FOR_APPROVAL_STATUS, text: STATUSES_RU.FOR_APPROVAL_STATUS},
            {status: Statuses.IN_WORK_STATUS, text: STATUSES_RU.IN_WORK_STATUS},
            {status: Statuses.REJECTED_STATUS, text: STATUSES_RU.REJECTED_STATUS},
        ],
        conditions: {isStaff: false, role: 'project_editor'}
    },
]


const StatusPopover = (props) => {
    const {status, anchorEl, onClose} = props

    const classes = useStyles()

    const [projectList, setProjectList] = useState([])

    const projects = useSelector(selectProjects)
    const projectStatuses = useSelector(selectProjectsStatuses)
    const {contracts} = useSelector(selectContracts)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getProjects())
    }, [])


    useEffect(() => {
        if (status) {
            setProjectList(projects
                .map(project => ({
                    project: project.name,
                    contract: contracts.find(contract => contract.id === project.contract)?.name,
                    count: projectStatuses[project.id].filter(act => act.status === status).length
                }))
                .filter(listItem => listItem.count > 0)
            )
        }
    }, [status])

    if (projectList.length === 0) {
        return null
    } else {
        return (
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={onClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Paper className={classes.popoverPaper} elevation={0}>
                    <List>
                        {
                            projectList.map(listItem => <ListItem button>
                                <ListItemText
                                    primary={listItem.project}
                                    secondary={listItem.contract}
                                />
                                <ListItemSecondaryAction>
                                    {listItem.count}
                                </ListItemSecondaryAction>
                            </ListItem>)
                        }
                    </List>
                </Paper>
            </Popover>
        );
    }
}

const StatusButtonGroup = () => {
    const dispatch = useDispatch()

    const projects = useSelector(selectProjects)
    const statuses = useSelector(selectActsStatuses)
    const {user} = useSelector(getProfile)
   
    const [groupConfig, setGroupConfig] = useState(undefined)
    const [anchorEl, setAnchorEl] = useState(null)
    const [selectedStatus, setSelectedStatus] = useState(null)

    const [ flag, setFlag] = useState(false)

    useEffect(() => {
        dispatch(getProjects())
    }, [])

    // useEffect(() => {
    //     if (projects.length > 0) {
    //         dispatch(getProjectsStatistic(projects))
    //     }
    // }, [projects])

    const handlePopoverOpen = (selectedStatus) =>  (event) => {
        
        setSelectedStatus(selectedStatus)
        setAnchorEl(event.target)
    }

    const handlePopoverClose = () => {
        setAnchorEl(null)
        setSelectedStatus(null)
    }

    useEffect(() => {
        setGroupConfig(configs.find(config => checkCondition(config.conditions, user)))
    }, [user])

    useEffect(() => {
        if (groupConfig) {
            for (const button of groupConfig.buttons) {
                dispatch(getActsByStatus(button.status))
            }
        }
    }, [groupConfig])


    return (
        <>
            <ButtonGroup color="primary">
                {groupConfig?.buttons?.map((button, index) => <StatusButton
                    key={`status-button-${index}`}
                    text={button.text}
                    count={statuses[button.status]}
                    onClick={
                        
                        handlePopoverOpen(button.status)
                    }
                />)}
            </ButtonGroup>
         
            <StatusPopover status={selectedStatus} anchorEl={anchorEl} onClose={handlePopoverClose}/>
        </>
    );
};

export default StatusButtonGroup;